var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1399 11.8682C25.1399 12.3077 24.7862 12.664 24.3499 12.664L24.34 12.6441C24.1305 12.6441 23.9295 12.5602 23.7814 12.411C23.6332 12.2618 23.55 12.0593 23.55 11.8483V10.2367C23.5232 7.52841 21.3503 5.33949 18.6619 5.31254H9.29049C6.60202 5.33949 4.42913 7.52841 4.40237 10.2367V17.2798C4.42913 19.9881 6.60202 22.177 9.29049 22.204H18.6619C21.3503 22.177 23.5232 19.9881 23.55 17.2798C23.5952 16.8719 23.9375 16.5634 24.3449 16.5634C24.7523 16.5634 25.0947 16.8719 25.1399 17.2798C25.129 20.8793 22.2351 23.7946 18.6619 23.8056H9.29049C5.71505 23.8001 2.81794 20.8816 2.8125 17.2798V10.2367C2.8125 6.63263 5.7128 3.71094 9.29049 3.71094H18.6619C22.2351 3.72186 25.129 6.63716 25.1399 10.2367V11.8682ZM14.8005 13.5996L19.3924 9.89899H19.4023C19.7442 9.62518 20.2409 9.67832 20.5182 10.0184C20.6502 10.1841 20.711 10.3962 20.6868 10.6074C20.6627 10.8186 20.5558 11.0112 20.3898 11.1425L15.7979 14.853C14.6303 15.7995 12.9661 15.7995 11.7985 14.853L7.19679 11.1425C6.85924 10.8632 6.80649 10.3628 7.07829 10.0184C7.20823 9.85328 7.39852 9.74767 7.60646 9.72523C7.81441 9.70278 8.02259 9.76538 8.18429 9.89899L12.8255 13.5996C13.4053 14.0578 14.2208 14.0578 14.8005 13.5996Z",
    fill: "#395E9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.fdf53fdea7ac6166fdbbc84b38863d31.svg";
export { ForwardRef as ReactComponent };